import React__default from 'react';
import { useLastInternalPage } from '@invitae/header-footer';
import { BrowserContextProvider } from '@invitae/nucleobase-core';

var BrowserProvider = function (_a) {
    var router = _a.withBrowserHistory, children = _a.children, browserActions = _a.browserActions;
    var lastPageVisited = useLastInternalPage({ router: router });
    if (!router)
        return React__default.createElement(React__default.Fragment, null, children);
    return (React__default.createElement(BrowserContextProvider, { value: { browserActions: browserActions, history: lastPageVisited !== null && lastPageVisited !== void 0 ? lastPageVisited : '' } }, children));
};

export { BrowserProvider as default };
//# sourceMappingURL=BrowserProvider.esm.js.map
